module.exports = __webpack_public_path__ + "static/media/TN-Men-Sneakers-2.0.e68380fe.svg";